"use client"
import { BookOpen } from "lucide-react"
import Link from "next/link"
import { usePathname } from "next/navigation"

export const Footer = () => {
  const pathname = usePathname()

  if (pathname.startsWith("/admin")) {
    return null
  }

  return (
    <footer className="bg-muted text-muted-foreground">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 px-4 md:px-6 py-12">
        <div className="flex flex-col gap-4">
          <Link href="/" className="flex items-center gap-2">
            <BookOpen className="h-6 w-6 text-primary" />
            <span className="font-bold text-lg text-foreground">软考通</span>
          </Link>
          <p className="text-sm">
            一个专注于计算机软件资格考试（软考）的在线学习与测试平台。
          </p>
        </div>
        <div>
          <h4 className="font-semibold text-foreground mb-4">快速链接</h4>
          <nav className="flex flex-col gap-2">
            <Link href="/subjects" className="hover:text-primary">
              科目总览
            </Link>
            <Link href="/test" className="hover:text-primary">
              在线测试
            </Link>
            <Link href="/pricing" className="hover:text-primary">
              价格
            </Link>
            <Link href="/about" className="hover:text-primary">
              关于我们
            </Link>
          </nav>
        </div>
        <div>
          <h4 className="font-semibold text-foreground mb-4">法律</h4>
          <nav className="flex flex-col gap-2">
            <Link href="/terms" className="hover:text-primary">
              服务条款
            </Link>
            <Link href="/privacy" className="hover:text-primary">
              隐私政策
            </Link>
          </nav>
        </div>
        <div>
          <h4 className="font-semibold text-foreground mb-4">联系我们</h4>
          <p className="text-sm">Email: contact@ruankao.com</p>
          <p className="text-sm">地址: 中国北京市海淀区</p>
        </div>
      </div>
      <div className="border-t">
        <div className="container mx-auto flex justify-between items-center px-4 md:px-6 py-4">
          <p className="text-sm">
            &copy; {new Date().getFullYear()} 软考通. 保留所有权利.
          </p>
        </div>
      </div>
    </footer>
  )
}
